import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoSuitcase = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5712_11813)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10.2315 1.62159H12.0016H13.7717C14.0048 1.62159 14.1938 1.81022 14.1938 2.04352H15.6829C15.6829 2.04352 15.6829 1.29061 15.6829 0.959625C15.6829 0.628969 15.4689 0.328734 15.145 0.260438C14.7315 0.173719 14.2846 0.219375 13.9871 0.173719C13.4493 0.0909375 12.4151 0 12.0016 0C11.588 0 10.5539 0.0909375 10.0162 0.173719C9.71869 0.219328 9.27173 0.173719 8.85806 0.260438C8.53434 0.328734 8.32031 0.628969 8.32031 0.959625C8.32031 1.29061 8.32031 2.04352 8.32031 2.04352H9.80939C9.80944 1.81022 9.99844 1.62159 10.2315 1.62159Z",
				fill: "#9095B5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.3169 5.63525H6.68467C5.57739 5.63525 4.67969 6.53305 4.67969 7.64024V19.555C4.67969 20.6621 5.57734 21.5596 6.68467 21.5596H17.3169C18.4241 21.5596 19.3216 20.6621 19.3216 19.555V7.64024C19.3216 6.53305 18.424 5.63525 17.3169 5.63525ZM17.9963 19.555C17.9963 19.9296 17.6915 20.2344 17.3169 20.2344H6.68467C6.30986 20.2344 6.00494 19.9296 6.00494 19.555V7.64024C6.00494 7.26561 6.30986 6.9605 6.68467 6.9605H17.3169C17.6916 6.9605 17.9964 7.26561 17.9964 7.64024V19.555H17.9963Z",
				fill: "#9095B5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.66694 2.56982H8.46094V5.18536H9.66694V2.56982Z",
				fill: "#9095B5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5419 2.56934H14.3359V5.27285H15.5419V2.56934Z",
				fill: "#9095B5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.54459 24.0003C8.10425 24.0003 8.55794 23.5466 8.55794 22.987C8.55794 22.4273 8.10425 21.9736 7.54459 21.9736C6.98494 21.9736 6.53125 22.4273 6.53125 22.987C6.53125 23.5466 6.98494 24.0003 7.54459 24.0003Z",
				fill: "#9095B5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.4507 21.9736C15.891 21.9736 15.4375 22.4272 15.4375 22.987C15.4375 23.5467 15.891 24.0003 16.4507 24.0003C17.0104 24.0003 17.464 23.5467 17.464 22.987C17.464 22.4273 17.0104 21.9736 16.4507 21.9736Z",
				fill: "#9095B5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.0391 9.63965H8.96523C8.72125 9.63965 8.52344 9.83737 8.52344 10.0813C8.52344 10.3256 8.72125 10.5232 8.96523 10.5232H15.0391C15.283 10.5232 15.4809 10.3256 15.4809 10.0813C15.4809 9.83732 15.283 9.63965 15.0391 9.63965Z",
				fill: "#9095B5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.0391 13.063H8.96523C8.72125 13.063 8.52344 13.2607 8.52344 13.5046C8.52344 13.7489 8.72125 13.9466 8.96523 13.9466H15.0391C15.283 13.9466 15.4809 13.7489 15.4809 13.5046C15.4809 13.2607 15.283 13.063 15.0391 13.063Z",
				fill: "#9095B5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.0391 16.4863H8.96523C8.72125 16.4863 8.52344 16.684 8.52344 16.928C8.52344 17.1722 8.72125 17.3699 8.96523 17.3699H15.0391C15.283 17.3699 15.4809 17.1722 15.4809 16.928C15.4809 16.684 15.283 16.4863 15.0391 16.4863Z",
				fill: "#9095B5"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5712_11813",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgIcoSuitcase;
